exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media only screen and (min-width:641px){.add__file[data-v-0bd70089]{grid-area:1/1/2/3}}@media only screen and (min-width:641px){.add__dop[data-v-0bd70089]{grid-area:3/1/4/3}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0bd70089","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/profile/views/progress/forms/resultform/AddResult.vue
// module id = c662b78ec4c007c14a4f
// module chunks = 46